export enum Status {
  WaitingForResponse,
  Idle,
}

export enum Step {
  Validate,
  Tracks,
  Export,
}
